import { isPhone } from '../../../utils/validators/generalValidators';
import { setPhoneErrors } from './profileReducer';
import { patchCustomerDetails } from './profileAPI';

export function validatePhones(
  dispatch,
  primaryPhone,
  secondaryPhone,
  primaryPhoneType,
  secondaryPhoneType,
  oldPrimaryPhoneNumber,
  oldPrimaryPhoneName,
  oldSecondaryPhoneNumber,
  oldSecondaryPhoneType,
) {
  const newErrors = [];
  const phoneTypes = ['Mobile', 'Home', 'Business', 'Other'];
  if (!isPhone(primaryPhone)) {
    newErrors.push('Please enter a valid primary phone number.');
  }
  if (!phoneTypes.includes(primaryPhoneType)) {
    newErrors.push('Please select primary phone number type.');
  }
  if (
    primaryPhone === oldPrimaryPhoneNumber &&
    primaryPhoneType === oldPrimaryPhoneName &&
    secondaryPhone === oldSecondaryPhoneType &&
    secondaryPhoneType === oldSecondaryPhoneType
  ) {
    newErrors.push('Please select a new phone type or enter a new phone number');
  }

  if (newErrors.length !== 0) {
    dispatch(setPhoneErrors(newErrors[0]));
  }

  return newErrors.length === 0;
}

export const savePhones = (
  props,
  newPrimaryPhone,
  newSecondaryPhone,
  primaryPhoneSelect,
  secondaryPhoneSelect,
  oldSecondaryPhoneNumber,
  oldSecondaryPhoneType,
) => {
  return dispatch => {
    const {
      customerParty,
      customer,
      phoneNumberPrimaryRetrieved,
      primaryPhoneName,
      phoneNumberPrimaryId,
      phoneNumberSecondary,
      phoneNumberSecondaryId,
      systemId,
    } = props;
    if (
      validatePhones(
        dispatch,
        newPrimaryPhone,
        newSecondaryPhone,
        primaryPhoneSelect,
        secondaryPhoneSelect,
        phoneNumberPrimaryRetrieved,
        primaryPhoneName,
        oldSecondaryPhoneNumber,
        oldSecondaryPhoneType,
      )
    ) {
      let body = {
        partyInfo: [
          {
            id: customerParty.id,
            phoneInfo: [],
          },
        ],
        _revision: customer._revision,
      };
      if (
        newPrimaryPhone !== phoneNumberPrimaryRetrieved ||
        primaryPhoneSelect !== primaryPhoneName
      ) {
        body.partyInfo[0].phoneInfo.push({
          id: phoneNumberPrimaryId,
          phoneNumber: newPrimaryPhone,
          phoneName: primaryPhoneSelect,
        });
      }
      if (
        newSecondaryPhone !== oldSecondaryPhoneNumber ||
        secondaryPhoneSelect !== oldSecondaryPhoneType
      ) {
        body.partyInfo[0].phoneInfo.push({
          id: phoneNumberSecondaryId,
          phoneNumber: newSecondaryPhone,
          phoneName: secondaryPhoneSelect ? secondaryPhoneSelect : '',
        });
      }
      if (
        newPrimaryPhone !== phoneNumberPrimaryRetrieved ||
        newSecondaryPhone !== phoneNumberSecondary ||
        primaryPhoneSelect !== primaryPhoneName ||
        secondaryPhoneSelect !== oldSecondaryPhoneType
      ) {
        dispatch(patchCustomerDetails(systemId, body, 'Phone'));
      }
    }
  };
};
